import { queryData } from '@/core/graphqlClient/queryClient';
import { getPlatform, isB2B } from '@/core/settings/utils';
import { Market, Platform, SProduct } from '@/generated/graphql/types';
import { WithSponsoredData } from '@/productDiscovery/Recommendation/interfaces/product';
import {
  SpDataAddToCartPageDocument,
  SpDataCartPageDocument,
} from '@/sellerAdsManagement/SponsoredProducts/services/graphql/listExistingByProduct/generated/listExistingByProduct.generated';

export const fetchExistingListByProductGql = (
  productIds: string[],
  location: 'ADD_TO_CART_PAGE' | 'CART_PAGE',
  abt?: string,
): Promise<WithSponsoredData[]> => {
  const documentQuery =
    location === 'ADD_TO_CART_PAGE'
      ? SpDataAddToCartPageDocument
      : SpDataCartPageDocument;
  return queryData(documentQuery, {
    context: {
      market: (isB2B() ? 'B2B' : 'B2C') as Market,
      platform: getPlatform().toUpperCase() as Platform,
      device: 'DESKTOP',
      location,
      abt: abt || null,
    },
    products: {
      productIds,
    },
  }).then((result: any) => {
    if (result && result.sProducts && result.sProducts.listExistingByProducts) {
      const sProductList = result.sProducts.listExistingByProducts;
      return sProductList.products && sProductList.products.length > 0
        ? sProductList.products.map((product: SProduct) => {
            return {
              adPayer: product.adPayer,
              adTrackingData: product.adTrackingData,
              cpc: product.mgr || 0,
              productId: product.channelOffer!.productId,
              isSponsored: true,
            };
          })
        : [];
    }
    return [];
  });
};
